import axios from "axios";
import config from "../config";

const partnerManagementService = axios.create({
  baseURL: config("service").partner
});

export default partnerManagementService;
